import { observable, action,   decorate } from 'mobx';

class DGRBackgroundStore {
    isBlurred: true
    isExpanded: true
    showHeader: false
    showBlurAndHeader(){
        this.isBlurred = true 
        this.isExpanded = true 
        this.showHeader = true 
    }
    hideBlurAndHeader(){
        this.isBlurred = false 
        this.isExpanded = false 
        this.showHeader = false 
    }
}

decorate( DGRBackgroundStore, {
    isBlurred: observable, 
    isExpanded: observable,
    showHeader: observable, 
    showBlurAndHeader: action,
    hideBlurAndHeader: action
})

export default new DGRBackgroundStore()





// WEBPACK FOOTER //
// ./src/stores/DGRBackgroundStore/index.js